import {
  Button as LibButton,
  UnstyledButton,
  // @ts-expect-error - TS7016 - Could not find a declaration file for module '@spaced-out/ui-lib/lib/button'. '/Users/diwaker/SpacedOut/ui-server/node_modules/@spaced-out/ui-lib/lib/button/index.js' implicitly has an 'any' type.
} from '@spaced-out/ui-lib/lib/button';
import {
  makeClassNameComponentCustom,
  ClassNameComponent,
  // @ts-expect-error - TS7016 - Could not find a declaration file for module '@spaced-out/ui-lib/lib/utils/makeClassNameComponent'. '/Users/diwaker/SpacedOut/ui-server/node_modules/@spaced-out/ui-lib/lib/utils/makeClassNameComponent.js' implicitly has an 'any' type.
} from '@spaced-out/ui-lib/lib/utils/makeClassNameComponent';

import css from './button.css';


export const Button: ClassNameComponent<typeof LibButton> =
  makeClassNameComponentCustom(css.button, LibButton);
export default Button;

export {UnstyledButton};
